const placeholders = new WeakMap();

function rememberOriginalPosition(block) {
  if (placeholders.has(block) || !block.parentNode) return;
  const marker = document.createComment('payment-flags-original-position');
  block.parentNode.insertBefore(marker, block);
  placeholders.set(block, marker);
}

function restoreOriginalPosition(block) {
  const marker = placeholders.get(block);
  if (marker?.parentNode && marker.nextSibling !== block) {
    marker.parentNode.insertBefore(block, marker.nextSibling);
  }
}

function positionPaymentBlock(block) {
  rememberOriginalPosition(block);

  if (block.dataset.moveBelowBuyButton !== 'true') {
    restoreOriginalPosition(block);
    return;
  }

  const scope = block.closest('.product-details, .product-information, .shopify-section') || document;
  const buyButton = scope.querySelector('[data-checkout-direct]');
  const buyButtonWrapper = buyButton?.closest('.dm-checkout-wrap');

  if (buyButtonWrapper && buyButtonWrapper.nextElementSibling !== block) {
    buyButtonWrapper.insertAdjacentElement('afterend', block);
  }
}

function positionAllPaymentBlocks() {
  document.querySelectorAll('[data-payment-flags-block]').forEach(positionPaymentBlock);
}

let scheduled = false;
function schedulePositioning() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    positionAllPaymentBlocks();
  });
}

document.addEventListener('shopify:section:load', schedulePositioning);
document.addEventListener('shopify:block:select', schedulePositioning);

const observer = new MutationObserver(schedulePositioning);
observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['data-move-below-buy-button'],
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', positionAllPaymentBlocks, { once: true });
} else {
  positionAllPaymentBlocks();
}
